import { BotMessageTemplateType } from "src/services/content-type/bot-message-template";

export default {
  afterCreate: async ({params, result}) => {
    await strapi.plugin('telegram-bot').service<BotMessageTemplateType>('bot-message-template').renewCache();
  },
  afterUpdate: async ({params, result}, states) => {
    await strapi.plugin('telegram-bot').service<BotMessageTemplateType>('bot-message-template').renewCache();
  },
}
